import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export default class Modal extends React.Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    children: PropTypes.any.isRequired,
    buttons: PropTypes.element,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    className: PropTypes.string,
    large: PropTypes.bool
  };

  static defaultProps = {
    className: "",
    isOpen: false,
    large: true
  };

  renderHeader() {
    const { title, subtitle } = this.props;
    return (
      <div className="modal-header">
        <div>
          <h4 className="modal-title">{title}</h4>
          {subtitle && <h5 className="modal-subtitle">{subtitle}</h5>}
        </div>
        <button type="button" className="close" aria-labelledby="Close" onClick={this.props.toggle}>
          <span aria-hidden="true">×</span>
        </button>
      </div>
    );
  }

  render() {
    const { isOpen, toggle, children, buttons, title, className, large } = this.props;

    return (
      <React.Fragment>
        <div
          className={classNames("modal-backdrop", { show: isOpen })}
          style={{ display: isOpen ? "block" : "none" }}
        />

        <div
          className={classNames("modal", { show: isOpen }, className)}
          style={{ display: isOpen ? "block" : "none" }}
          onClick={({ target }) => {
            target.classList.contains("modal") && toggle();
          }}
        >
          <div className={classNames("modal-dialog", { "modal-lg": large })}>
            <div className="modal-content">
              {title && this.renderHeader()}
              <div className="modal-body">{children}</div>
              {buttons && <div className="modal-footer">{buttons}</div>}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
